import React from 'react';

function UserFilter() {
  return <div />;
}

export default UserFilter;
